import _ from "lodash";

// regex for Email Address input field
export const regexForEmailAddress =
  // eslint-disable-next-line no-useless-escape, no-control-regex
  /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;

// regex for Email Address input field
export const regexForMobileNumber = /^[0-9]{10}$/;
/* Regex for strong password Explanation:
^                 # start-of-string
(?=.*[0-9])       # a digit must occur at least once
(?=.*[a-z])       # a lower case letter must occur at least once
(?=.*[A-Z])       # an upper case letter must occur at least once
(?=.*[@#$%^&+=])  # a special character must occur at least once
(?=\S+$)          # no whitespace allowed in the entire string
.{8,}             # anything, at least eight places though
$                 # end-of-string */
export const regexForPassword =
  /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=])(?=\S+$).{8,}$/;

export const regexForName = /^[a-zA-Z ]{2,30}$/;
export const regexForLastName = /^[a-zA-Z ]{1,30}$/;

/* Global Errors state utils */
export const getErrorMessage = (errors, fieldName, fieldLabel, field) => {
  if (errors[fieldName]) {
    const { type } = errors[fieldName];
    switch (type) {
      case "required":
        return `${fieldLabel} is required`;
      case "sameAs":
        return "Passwords did not match. Please try again.";
      case "pattern":
        if(fieldLabel === "Password" || fieldLabel === "Confirm Password"){
          return `Password must contain at least 8 characters and contain one uppercase letter, one lowercae letter, one number & one special charater`;
        }
        return `Invalid ${fieldLabel}`;
      case "maxLength":
        if(fieldLabel === "Mobile Number"){
          return `Mobile Number can't be more than 10-digits`;
        }
        if(fieldLabel === "Password"){
          return `Password must contain at least 8 characters and contain one uppercase letter, one lowercae letter, one number & one special charater`;
        }
        if(field?.maxLength) {
          return `${fieldLabel} length must be lesser than ${field?.maxLength} characters long`;
        }
        return `${fieldLabel} length must be lesser than 10 characters long`;
      case "minLength":
        if(fieldLabel === "mobileNumber"){
          return `Mobile Number should be of 10-digits`;
        }
        if(field?.minLength) {
          return `${fieldLabel} length at least ${field?.minLength} characters long`;
        }
        return `${fieldLabel} length at least 10 characters long`;
      default:
        // eslint-disable-next-line no-console
        console.error(`Unknow error type: ${type}`);
        return type;
    }
  } else {
    return false;
  }
};

/* Initial Parameter of Axios Request */
export const axiosInitialParams = {
  cache: "no-cache",
  credentials: "same-origin",
  headers: {
    "content-type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
  mode: "cors",
  redirect: "follow",
  referrer: "no-referrer",
  withCredentials: true,
};

export const getDataType = (type) => {
  if (type === "NUMERIC") {
    return "number";
  } else if (type === "ALPHANUMERIC") {
    return "text";
  } else {
    return "text";
  }
};

export const getTenantName = (name) => {
  if (name["tenant-name"]) {
    localStorage.setItem("currentTenantName", name["tenant-name"]);
    return name["tenant-name"];
  } else if (_.isEmpty(name) && localStorage.getItem("currentTenantName")) {
    const currentTenantName = localStorage.getItem("currentTenantName");
    return currentTenantName;
  } else if (
    !name["tenant-name"] &&
    !localStorage.getItem("currentTenantName")
  ) {
    return process.env.REACT_APP_TENANT_NAME;
  } else if (_.isEmpty(name)) {
    return process.env.REACT_APP_TENANT_NAME;
  }
};

export const imageUploadSpecialCharsReplacePattern = /[^-_.A-Za-z0-9]/g;
export const allowedImageTypes = ['png', 'PNG', 'jpg', 'JPG'];
export const inValidFileTypeErrorMessage = "Invalid file type, allowed file types are 'JPG' and 'PNG'.";
export const regexForShortName = /^[a-zA-Z0-9 _.-]+$/;
export const regexForShortNameBill = /^[a-zA-Z0-9]{3,75}$/;
export const regexForProfile = /[^a-zA-Z0-9. ]/;
